module.exports = __webpack_public_path__ + "9bfa644f377fafe554f3409afecd99aa.svg";